import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const commentApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/comments/`, {params: params})
  },
  detail (commentId, params) {
    // params: {}
    return axios.get(`${ApiSetting.baseUrl}/api/comments/${commentId}/`, {params: params})
  },
  create (params) {
    // 创建新评论
    return axios.post(
      // `${ApiSetting.baseUrl}/api/comments/`, querystring.stringify(params))
      `${ApiSetting.baseUrl}/api/comments/`, querystring.stringify(params))
  },
  close (commentId) {
    return axios.post(`${ApiSetting.baseUrl}/api/comments/${commentId}/close/`)
  },
  count (params) {
    // 计算评论对象的总评论数
    return axios.get(`${ApiSetting.baseUrl}/api/comments/count/`, {params: params})
  },
  most_liked (params) {
    // 获取评论对象赞数最高的评论（comment id 数组）
    return axios.get(`${ApiSetting.baseUrl}/api/comments/most_liked/`, {params: params})
  },
  // hot (params) {
  //   // 获取show下热门评论（按赞数达标时间排序，不按赞数排序）
  //   return axios.get(`api/comments/hot/`, {params: params})
  // }
}

export default commentApi
